import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

FnrUserPhoto.propTypes = {
  url: PropTypes.string,
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  style: PropTypes.object,
  hideShadow: PropTypes.bool,
};

export default function FnrUserPhoto({
  url,
  size = 40,
  borderWidth = 0,
  style = {},
  hideShadow = false,
}) {
  const src = url || "//dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg";

  return (
    <ImgWrapper
      $imgSrc={src}
      size={size}
      borderWidth={borderWidth}
      style={style}
      hideShadow={hideShadow}
    />
  );
}

const ImgWrapper = styled.div`
  background-image: ${({ $imgSrc }) => `url(${$imgSrc})`};
  height: ${({ size }) => `${size}px`};
  width: ${({ size }) => `${size}px`};
  flex-shrink: 0;
  flex-grow: 0;
  border-radius: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: white;
  box-shadow: ${({ hideShadow }) =>
    hideShadow ? null : "0 2px 4px 0 rgba(0, 0, 0, 0.2);"};
  border: ${({ borderWidth }) => `${borderWidth}px`} solid white;
`;
